<template lang="html">
<div class="main-body">
    <div class="main-body-search">
        <el-form :inline="true" :model="filters" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="filters.menuName" placeholder="菜单名称" @keyup.enter.native="getList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList" >查询</el-button>
          </el-form-item>
        </el-form>
    </div>
    <div class="main-body-table">
      <!--列表-->
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column type="index" width="60">
        </el-table-column>
        <el-table-column
          prop="menuName"
          label="菜单名称"
          width="200">
        </el-table-column>
        <el-table-column
          prop="menuNote"
          label="描述"
          width="300">
        </el-table-column>
        <el-table-column
          prop="menuTag"
          label="API"
          width="400">
          <template slot-scope="scope">
            <span style="margin : 0px 5px 0px 0px;" v-for="api in scope.row.apiList" :key="api.apiName">
              <el-tag>{{api.apiName}}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="appName"
          label="所属应用">
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-pagination class="main-body-table-page" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size" :total="page.total">
      </el-pagination>
  </div>
</div>
</template>

<script>
import { getMenus } from '../../api/sum/Menu'
export default {
  data () {
    return {
      // 模拟数据 start
      menuTypes: [
        { code: '0', name: 'static' },
        { code: '1', name: 'dynamic' },
        { code: '2', name: 'third' }
      ],
      apis: [
        { id: '', name: '新增' },
        { id: '', name: '修改' },
        { id: '', name: '删除' },
        { id: '', name: '查询' }
      ],
      // 模拟数据 end
      filters: {
        menuName: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: []
    }
  },
  mounted () {
    // 默认查询
    this.getList()
  },
  methods: {
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    // 查询
    getList () {
      this.filters.current = this.page.current
      this.filters.size = this.page.size
      getMenus(this.filters).then(response => {
        // {value, code}
        this.tableData = response.data.records
        this.page.total = response.data.total
      }).catch(err => {
        // {data, status}
        console.log(err)
      })
    }
  }
}
</script>

<style lang="css">
</style>
